/*
 * Helper functions for bitwise flag operations.
 */

export function hasFlag(value: number | null | undefined, flag: number | null | undefined): boolean {
    return ((value ?? 0) & (flag ?? 0)) !== 0;
}

export function hasAnyFlag(value: number | null | undefined, flags: (number | null | undefined)[]): boolean {
    return flags.some(flag => ((value ?? 0) & (flag ?? 0)) !== 0);
}

export function hasAllFlags(value: number | null | undefined, flags: number[]): boolean {
    return flags.every(flag => ((value ?? 0) & (flag ?? 0)) === flag);
}
